import app from "../_app";
import {showHideDeliveryTime} from "./product";

const product = document.querySelector('.js-product');
const bundle = product ? product.querySelector('.js-product-bundle') : null;

if(bundle) {
    const price = product.querySelectorAll('.js-product-price');
    const selectedItemsInput = bundle.querySelector('.js-bundle-selected-items');
    const bundleVariants = [...bundle.querySelectorAll('.js-bundle-variant')];
    const discount = parseFloat(bundle.dataset.discount) || 0;

    const getSelectedVariants = () => [...bundle.querySelectorAll('.js-bundle-variant:checked')];

    // The discount is rounded down to a whole currency unit because this store only sells at
    // whole prices. Keep this identical to product-bundle-price.liquid and to the cart transform,
    // otherwise the price shown on the PDP drifts from the price charged in the cart.
    const getBundlePrice = (selectedVariants) => {
        const subtotal = selectedVariants.reduce((total, variant) => total + parseInt(variant.dataset.price, 10), 0);

        return Math.floor(subtotal * (100 - discount) / 10000) * 100;
    };

    // A bundle ships no faster than its scarcest item.
    const getBundleQuantity = (selectedVariants) => Math.min(
        ...selectedVariants.map(variant => parseInt(variant.dataset.quantity, 10))
    );

    const bundleChangeHandler = () => {
        const selectedVariants = getSelectedVariants();
        const bundlePrice = getBundlePrice(selectedVariants);

        showHideDeliveryTime(getBundleQuantity(selectedVariants));

        price.forEach((priceElement) => {
            priceElement.setAttribute('data-price', bundlePrice);
            priceElement.innerText = app.currency(bundlePrice);
        });

        selectedItemsInput.value = JSON.stringify(selectedVariants.map(variant => ({
            merchandiseId: `gid://shopify/ProductVariant/${variant.value}`,
            productId: `gid://shopify/Product/${variant.dataset.productId}`,
            productHandle: variant.dataset.productHandle,
            price: variant.dataset.price,
            quantity: '1',
        })));
    };

    // Runs after the variant init in product.js, which would otherwise leave the parent
    // product price in place.
    setTimeout(bundleChangeHandler, 1);

    // On a back navigation the browser restores the selected variants, but the price comes from the
    // cached markup. pageshow fires after that restore, so the price catches up with the selection.
    window.addEventListener('pageshow', bundleChangeHandler);

    bundleVariants.map(variant => variant.addEventListener('change', bundleChangeHandler));
}
